module.exports = __webpack_public_path__ + "static/media/mail.463b80a6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Header/mail.svg
// module id = 1794
// module chunks = 0